import { createRoutine } from 'redux-saga-routines';

export const fetchReminderTemplateRoutine = createRoutine('FETCH_REMINDER_TEMPLATE');
export const candidateSendReminderRoutine = createRoutine('CANDIDATE_SEND_REMINDER');
